module.exports = "<!-- Action buttons-->\r\n<div class=\"mt-2 d-print-none text-center\">\r\n    <button type=\"button\" class=\"btn btn-link\" (click)=\"print()\">\r\n        <i class=\"mdi mdi-printer mdi-18px\"></i>\r\n        IMPRIMIR\r\n    </button>\r\n    <button type=\"button\" class=\"btn btn-link\" (click)=\"descargar()\">\r\n        <i class=\" mdi mdi-download mdi-18px\"></i>\r\n        DESCARGAR\r\n    </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportes/creditos-colocados/components/footer/colocados-footer.component.html
// module id = ./src/app/reportes/creditos-colocados/components/footer/colocados-footer.component.html
// module chunks = main